import { createSlice } from '@reduxjs/toolkit';
import { IFormControl } from '../../../../../ui/forms/interfaces';
import { createControl } from '../../../../../domain/validation/validation';
import { default as cloneDeep } from 'lodash/cloneDeep';

interface ICouponState{
    couponControl: IFormControl,
    showCouponNavError: boolean,
}

/**
 * initial state
 */
const initialState: ICouponState = {
    couponControl: createControl('coupon', '', {
        required: true,
        requiredMessage: 'Please enter at least 4 characters.',

        minlength: 4,
        minlengthMessage: 'Please enter at least 4 characters.',

        regex: '^[ ]*[a-zA-Z0-9-]+[ ]*$',
        regexMessage: 'Invalid coupon code.',
    }),
    showCouponNavError: false,
};

const couponsSlice = createSlice({
    name: 'coupon',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setCouponControl(state, action) {
            return {
                ...state,
                couponControl: cloneDeep(action.payload),
            }
        },
    }
});

export default couponsSlice;